module.exports = __webpack_public_path__ + "img/gf-k.fb2e36de.png";